<div class="ui-g-12 ui-fluid">
  <div class="ui-g-6 ui-md-8 ui-sm-12 ui-lg-6">
    <div id="videoBig">
      <video id="videoOutput" autoplay width="100%" height="450px" poster="img/webrtc.png"></video>
    </div>
    <div id="videoSmall">
      <video id="videoInput" autoplay width="15%" height="180px" poster="img/webrtc.png" style="position: absolute; top: 181px; left: 354px;"></video>
    </div>
  </div>
  <div class="ui-g-6 ui-md-4 ui-sm-12 ui-lg-6">
    <div class="ui-g-12" style="display: flex; align-items: center;">
      <div class="ui-g-2" style="margin: 0 auto;">
        <img src="../../assets/images/telemedicina/compartir-imagen.png" style="width: 90%;">
      </div>
    </div>
    <div class="card" style="text-align: center;">
        <h2>Comparte una imagen <br> de tu consulta para más detalles</h2>
    </div>
    <div class="ui-g-12">
      <div class="container">
        <div class="ui-g">
            <div class="ui-g-12">
                    <p-toast></p-toast>
                    <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)"
                            multiple="multiple" accept="image/*,application/pdf" maxFileSize="1000000">
                        <ng-template pTemplate="content">
                            <ul *ngIf="uploadedFiles.length">
                                <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
            </div>
        </div>
    </div>
    </div>
    <div class="ui-g-12" style="align-content: center;">
     <!-- <button pButton type="button" label="Finalizar llamada"  class="boton1 ui-button-danger ui-widget" icon="pi pi-times"  style="width: 100%; font-weight: 800; padding: 6px;" (click)="stop(true)"></button>-->
      <button pButton type="button" label="Finalizar llamada"  class="boton1 ui-button-danger ui-widget" icon="pi pi-times"  style="width: 100%; font-weight: 800; padding: 6px;" (click)="registersw()"></button>
    </div>
  </div>
</div>

<p-dialog closable="false"  header="" [showHeader]="false" [(visible)]="displayWaitDialog" [minY]="70" [modal]="true"
          [style]="{width: '80%', height:'80%'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
  <div class="p-col-12 p-md-12" *ngIf="isOnline">
    <h2 style="font-weight: 800;">¡Esperando que la Doctora o el Doctor acepte!</h2>
      <div>
        <div style="text-align: center;">
          <i class="pi pi-user" style="font-size: 2em;"></i>
        </div>
        <h4 style="margin-top: 0;">Personas en cola</h4>
        <div *ngIf="quequePosition > -1">
        <h2 style="font-weight: 900; margin-bottom: 4%; color: #0f5feb;">{{quequePosition}}</h2>
      </div>
      <div>
        <div style="text-align: center;">
          <i class="pi pi-clock" style="font-size: 3em;"></i>
        </div>
        <h4 style="margin-top: 0;">Tiempo aproximado de espera:</h4>
        <h2 style="font-weight: 900; color: #0f5feb;">{{quequeTime}} minutos</h2>
      </div>
      <div>
        <h2>¿Quieres esperar?</h2>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6">
          <button  pButton type="button" class="ui-button-danger btn-dv" style="width: 60%;" label="Cancelar" (click)="exitWait()"></button>
        </div>
        <div class="ui-g-6">
          <button  pButton type="button" class=" btn-dv" style="width: 60%;" label="Aceptar" (click)="registersw()"></button>
        </div>

      </div>
    </div>
    <div *ngIf="quequePosition == -1">
      <h2>{{quequeVariable}}</h2>
    </div>
  </div>
</p-dialog>
